import React from 'react';

export const CategorySection = ({
  category,
  onResourceHover,
  hoveredIndex,
}) => {
  return (
    <div className="mb-8 last:mb-0">
      <h3 className="text-xl text-[#0C0D1A] font-semibold mb-4">
        {category.title}
      </h3>
      <p className="mb-3">{category.para}</p>
      <div className="flex flex-wrap gap-3">
        {category.items.map((resource, itemIndex) => {
          // Calculate global index from category start + item position
          const globalIndex = category.startIndex + itemIndex;
          const isActive = globalIndex === hoveredIndex;
          return (
            <a
              key={itemIndex}
              href={resource.pdfUrl}
              target="_blank"
              rel="noopener noreferrer nofollow"
              onMouseEnter={() => onResourceHover(globalIndex)}
              onFocus={() => onResourceHover(globalIndex)}
              className={`default-button-secondary-small whitespace-nowrap ${
                isActive ? 'border-[#006EB7] text-[#006EB7] underline' : ''
              }`}
            >
              {resource.title}
              
              {resource.status_tag && (
                <span className="ml-2 bg-[#006EB7] text-white text-xs font-semibold px-2 py-1 rounded-lg">
                  {resource.status_tag}
                </span>
              )}
            </a>
          );
        })}
      </div>
    </div>
  );
};
